/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_2_AInputs */

const en_mk_pricing_faq_2_a = /** @type {(inputs: Mk_Pricing_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent work pauses and the workspace owner is notified; you can top up quota anytime, without waiting for the monthly renewal.`)
};

const id_mk_pricing_faq_2_a = /** @type {(inputs: Mk_Pricing_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerja agen dijeda dan pemilik workspace diberi tahu; kamu bisa menambah kuota kapan saja tanpa menunggu perpanjangan bulanan.`)
};

/**
* | output |
* | --- |
* | "Agent work pauses and the workspace owner is notified; you can top up quota anytime, without waiting for the monthly renewal." |
*
* @param {Mk_Pricing_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_2_a = /** @type {((inputs?: Mk_Pricing_Faq_2_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_2_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_2_a(inputs)
	return en_mk_pricing_faq_2_a(inputs)
});